import { skipToken } from '@reduxjs/toolkit/query';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useAppSelector } from '@/redux/store';
import { useGetOrganizationAdditionalInfoQuery } from '@/redux/slices/organizationApiSlice';

export const useTermsAgreement = () => {
  const { ithAdpTermsAgreement } = useFlags();
  const organizationId = useAppSelector(
    state => state.loggedUser?.organizationId
  );

  const { data: additionalInfo, isLoading } =
    useGetOrganizationAdditionalInfoQuery(
      organizationId ? { organizationId } : skipToken
    );

  const shouldShowTermsAgreement =
    ithAdpTermsAgreement === true &&
    additionalInfo?.termsRequired === true &&
    additionalInfo?.termsAccepted === false;

  const isTermsAgreementLoading = ithAdpTermsAgreement === true && isLoading;

  return { shouldShowTermsAgreement, isTermsAgreementLoading };
};
